import React, { useState } from 'react';
import { Link, graphql } from 'gatsby';
import Seo from '@laradevitt/gatsby-theme-just-basics/src/components/seo';
import { withPrismicPreview } from 'gatsby-plugin-prismic-previews';
import { ArrowLeftIcon } from '@heroicons/react/24/solid';

import { Section } from '../components/Layout';
import { VideoModal } from '../components/Page';
import { ViewVideos } from '../components/Page/Views';

/* eslint-disable react/prop-types */
export const Head = ({ data }) => {

  const { prismicTag } = data;

  return (
    <Seo
      title={`Videos tagged with ${prismicTag.data.name}`}
      path={`/videos/tag/${prismicTag.uid}`}
    />
  );
}
/* eslint-enable react/prop-types */


const VideosTagTemplate = ({ data }) => {
  const { prismicTag } = data;

  const videos = prismicTag.content.videos;

  // setShowModal(false) to dismiss modal
  const [showModal, setShowModal] = useState(false);
  const [watchVideo, setWatchVideo] = useState({});

  const watchVideoSetState = (video) => {
    setWatchVideo(video);
    modalOpenState(true);
  }

  const modalOpenState = (state) => {
    setShowModal(state);
  }

  return (
    <div className="pb-16 2xl:pb-32">
      {watchVideo?.data?.embed?.html && (
        <VideoModal
          watchVideo={watchVideo}
          showModal={showModal}
          modalOpenState={modalOpenState}
        />
      )}
      <Section className="bg-off-white py-16 min-h-[10rem]">
        <div className="text-center pb-16">
          <h1 className="font-trade text-xl">
            <Link
              to="/videos/"
              className="no-underline"
            >
              Videos
            </Link>
          </h1>
        </div>
      </Section>
      <section className="py-16 pt-12">
        <div className="max-w-9xl px-6 mx-auto">
          <div className="max-w-8xl mx-auto">
            <div className="justify-between items-center mb-8">
              <Link
                to="/videos/"
                className="sm:order-2 flex items-center text-[1.3rem] mb-6"
              >
                <ArrowLeftIcon className="inline h-4 w-4 mr-2" aria-hidden="true" /> <span>Return to all videos</span>
              </Link>
              <h2 className="order-2 md:order-1 text-xl 2xl:text-[2.5rem] leading-[1.15]">
                <span className="font-numbers leading-[0.8] uppercase text-2xl 2xl:text-4xl">
                  {prismicTag.data.name}
                </span>
              </h2>
            </div>
            <ViewVideos videos={videos} watchVideoSetState={watchVideoSetState} />
          </div>
        </div>
      </section>
    </div>
  );
};

export default withPrismicPreview(VideosTagTemplate);

export const pageQuery = graphql`
  query ($uid: String!) {
    site {
      siteMetadata {
        title
        description
        author
        siteUrl
      }
    }
    prismicTag(
      uid: {
        eq: $uid
      }
    ) {
      content {
        videos {
          uid
          ...PrismicVideoFragment
        }
      }
      data {
        name
      }
      uid
    }
  }
`;
